import { render, staticRenderFns } from "./howToBuyView.vue?vue&type=template&id=d21d5bdc&"
import script from "./howToBuyView.vue?vue&type=script&lang=js&"
export * from "./howToBuyView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports